import colors from '@constants/colors';
import { IconProps } from '@models/icons';

function InfoIcon({ size = 24, color = colors.gray6, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path
                d="M11.7461 4.61719C15.5215 4.61739 18.583 7.67863 18.583 11.4541V11.7441C18.583 15.5196 15.5215 18.5809 11.7461 18.5811H11.4561C7.68044 18.5811 4.61914 15.5198 4.61914 11.7441V11.4541C4.61916 7.6785 7.68045 4.61719 11.4561 4.61719H11.7461ZM11.4561 5.49023C8.16244 5.49023 5.49221 8.16049 5.49219 11.4541V11.7441C5.49219 15.0378 8.16243 17.708 11.4561 17.708H11.7461C15.0395 17.7078 17.71 15.0376 17.71 11.7441V11.4541C17.7099 8.16062 15.0395 5.49044 11.7461 5.49023H11.4561ZM12.2549 14.8721H10.9463V10.9443H12.2549V14.8721ZM12.2549 9.63574H10.9463V8.32617H12.2549V9.63574Z"
                fill={color}/>
        </svg>
    );
}

export default InfoIcon;
